import {html} from 'lit-html';
import {styleMap} from 'lit-html/directives/style-map';
import {ifDefined} from 'lit-html/directives/if-defined';

const buttonAtcStyleMap = (option, styleMap = {}) => {
    if(option.params.atcColor){
        styleMap['color'] = option.params.atcColor;
    }
    if(option.params.atcBgColor){
        styleMap['backgroundColor'] = option.params.atcBgColor;
    }
    return styleMap;
}

const template = (previewEl, optionsEl, priceEl, config, onAdd, onClose) => html`
<div class="ldcv ${config.className}" >
    <div class="base">
        <div class="inner card">
            <div class="cl-po--popup">
                <div class="cl-po--popup-preview">
                    ${previewEl}
                </div>
                <div class="cl-po--popup-options cl--po-wrapper" id=${config.id}>
                    <div class="options-scroll">
                        ${config.visible ? optionsEl : null}
                    </div>
                    <div class="options-atc">
                        <div class="atc-wrap">
                            <div class="atc-price">
                                ${priceEl}
                            </div>
                            ${config.option.params.popupQty ?
                             html`<div class="atc-quantity">
                                 <input class="cl-po--input cl-po--quantity" type="number" inputmode="numeric" name="quantity" value="1" min="1" form=${ifDefined(config.productFormLink)} />
                             </div>` : null}
                            <div class="atc-button">
                                <button class="cl-po--swatch cl-po--swatch-button" @click="${(e) => onAdd(e)}" style=${styleMap(buttonAtcStyleMap(config.option))}>
                                    ${config.option.params.atcText || 'Add to Cart'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="cl-po--popup-close" @click="${(e) => onClose(e)}">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" ><path fill="none" d="M0 0h24v24H0z"/><path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm0-9.414l2.828-2.829 1.415 1.415L13.414 12l2.829 2.828-1.415 1.415L12 13.414l-2.828 2.829-1.415-1.415L10.586 12 7.757 9.172l1.415-1.415L12 10.586z"/></svg>
            </div>
        </div>
    </div>
</div>
`;
export default template;